import { Validators } from '@angular/forms';
import { CrudFormConfig, CrudFormSelectItem, CrudFormTextBoxItem, CrudViewFormItemType, FormLayout } from '@rappider/rappider-components/utils';
import { ProjectStructureType } from 'libs/shared/src/lib/definitions/project-structure-type.enum';
import { ProjectVisibility } from 'libs/shared/src/lib/definitions/project-visibility.enum';

export const ADMIN_PROJECTS_FORM_CONFIG: CrudFormConfig = {
  items: [
    {
      title: 'ID',
      fieldName: 'id',
      type: CrudViewFormItemType.TextBox,
      visible: false
    },
    {
      title: 'name',
      fieldName: 'name',
      type: CrudViewFormItemType.TextBox,
      visible: false
    },
    <CrudFormSelectItem>{
      title: 'Project Visibility',
      fieldName: 'visibility',
      type: CrudViewFormItemType.Select,
      options: [
        { key: 'Private', value: ProjectVisibility.Private },
        { key: 'Public', value: ProjectVisibility.Public }
      ],
      validators: [
        {
          type: Validators.required,
          errorKey: 'required',
          errorMessage: 'Please select a project visibility'
        }
      ]
    },
    <CrudFormSelectItem>{
      title: 'Project Structure Type',
      fieldName: 'structureType',
      type: CrudViewFormItemType.Select,
      options: [
        { key: 'Application', value: ProjectStructureType.Application },
        { key: 'Template', value: ProjectStructureType.Template},
        { key: 'Module', value: ProjectStructureType.Module }
      ],
      validators: [
        {
          type: Validators.required,
          errorKey: 'required',
          errorMessage: 'Please select a project structure type'
        }
      ]
    },
    <CrudFormTextBoxItem>{
      title: 'AI Token Limit',
      fieldName: 'aiTokenLimit',
      type: CrudViewFormItemType.Number
    }
  ],
  submitButton: { visible: false },
  formLayout: FormLayout.Horizontal
};

